import { render } from "./Communication.vue?vue&type=template&id=7d17ca08&scoped=true"
import script from "./Communication.vue?vue&type=script&lang=js"
export * from "./Communication.vue?vue&type=script&lang=js"

import "./Communication.vue?vue&type=style&index=0&id=7d17ca08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d17ca08"]])

export default __exports__